// extracted by mini-css-extract-plugin
module.exports = {"FileTable":"FileTable_FileTable__2qXvi"};